import * as tmpServicesSDK from '@tmp-services/sdk';

export import CopilotResponse = tmpServicesSDK.CareerCopilotModule.CopilotResponse;
/** Excludes unused "userRequest" property */
export import ReferenceType = tmpServicesSDK.CareerCopilotModule.ReferenceType;

export import CareerCopilotClient = tmpServicesSDK.CareerCopilotModule.CareerCopilotClient;

/** Handles Feedback */
export import ChatFeedbackRequest = tmpServicesSDK.CareerCopilotModule.ChatFeedbackRequest;
export import FeedbackClient = tmpServicesSDK.CareerCopilotModule.FeedbackClient;
export import ResponseFeedback = tmpServicesSDK.CareerCopilotModule.ResponseFeedback;
export import ChatMessageAuthor = tmpServicesSDK.CareerCopilotModule.Author;
export import ChatMessage = tmpServicesSDK.CareerCopilotModule.ChatMessage;
export import CopilotRequest = tmpServicesSDK.CareerCopilotModule.CopilotRequest;
export import ResponseCategories = tmpServicesSDK.CareerCopilotModule.ResponseCategory;
